import React, { useMemo } from "react";

import BaseTextContentInput from "../../component/input/TextContentInput";
import { get } from "lodash";
import { useFormState } from "react-final-form";
import { useTranslate } from "ra-core";

const TextContentInput = ({ ...props }) => {
  const { source, resource } = props;
  const formState = useFormState();
  const translate = useTranslate();
  const companyTypeId = useMemo(
    () => get(formState.values, "company.company_type_id"),
    [formState.values]
  );
  const helperText = translate(
    `resources.${resource}.fields.${companyTypeId}.${source}.help`
  );
  return <BaseTextContentInput {...props} helperText={helperText} />;
};
export default TextContentInput;
